<template lang="pug">
  v-card.mb-2(
    style="position:relative;padding-top:56.25%;"
    v-bind="$attrs"
  ).grey.lighten-2
      iframe(
      :src="videoLink"
      style="position:absolute;top:0;left:0;"
      width="100%"
      height="100%"
      frameBorder="0"
      allow="clipboard-write; autoplay, fullscreen"
      webkitAllowFullScreen
      mozallowfullscreen
      allowfullscreen
    )

</template>

<script>
const VIDEO_TYPES = {
  rutube: 1,
  youtube: 2,
  iframe: 3,
  vk: 4,
};

export default {
  name: 'ContentVideos',
  props: {
    video: { type: Object, required: true },
  },
  data() {
    return {
      model: 0,
      hover: false,
    };
  },
  computed: {
    videoType() {
      return Object.entries(VIDEO_TYPES).find(([key]) => this.video.link.includes(key))[1];
    },
    videoLink() {
      const byTypes = {
        [VIDEO_TYPES.rutube]: this.getRuTubeEmbed(this.video.link),
        [VIDEO_TYPES.youtube]: this.getYoutubeEmbedLink(this.video.link),
        [VIDEO_TYPES.iframe]: this.video.link,
        [VIDEO_TYPES.vk]: this.video.link,
      };
      return byTypes[this.videoType];
    },
  },
  methods: {
    getRuTubeEmbed(url) {
      const anchor = document.createElement('a');
      anchor.href = url;
      let videoPas;
      if (anchor.search) {
        const queryStrings = anchor.search.substring(1);
        const urlParams = new URLSearchParams(queryStrings);
        videoPas = urlParams.get('p');
      }
      // eslint-disable-next-line prefer-destructuring
      const urlSplited = anchor.pathname.substring(1).split('/');
      const id = urlSplited[urlSplited.length - 1] || urlSplited[urlSplited.length - 2];
      return `https://rutube.ru/play/embed/${id}${videoPas ? `/?p=${videoPas}` : ''}`;
    },
    getYoutubeVideoId(url) {
      try {
        let videoId;
        const anchor = document.createElement('a');
        anchor.href = url;
        // Если есть query-параметры, то ищем в них. Иначе берем всю часть после слеша.
        if (anchor.search) {
          const queryStrings = anchor.search.substring(1);
          const urlParams = new URLSearchParams(queryStrings);
          videoId = urlParams.get('v');
        } else {
          videoId = anchor.pathname.substring(1);
        }
        return videoId;
      } catch {
        throw new Error('Ошибка при получении ID видео');
      }
    },
    getYoutubeEmbedLink(url, isImg) {
      try {
        const videoId = this.getYoutubeVideoId(url);
        if (isImg) {
          return `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
        }
        return `https://www.youtube.com/embed/${videoId}`;
      } catch {
        throw new Error('Ошибка при вставке видео');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .opacity {
    opacity: .5;
  }
  .opacity:hover {
    opacity: 1;
  }
  .relative{
    position: relative;
  }
  .absolute {
    position: absolute;
    bottom: 50px;
  }
  // .v-icon.v-icon {
  //   background: white;
  // }
</style>
